import formValueSelector from "redux-form/lib/formValueSelector";
import { playerDecisionFormId } from "../components/PlayerDecisionForm";

const pFormSelector = formValueSelector(playerDecisionFormId);

export const selectPlayerFormPrice = state => pFormSelector(state, 'price');